import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchImageSlider } from 'redux/image-sliders/actions';

import CommonLinkCheckbox from 'components/common/link-elements/CommonLinkCheckbox';

import './InstagramSliderLinkedPosts.css';

function InstagramSliderLinkedPosts(props) {
  const { item, patchImageSlider } = props;
  const { t } = useTranslation();

  return (
    <div className="instagram-slider-linked-posts__component">
      <div className="label">{t('Linked Instagram Posts')}</div>
      <CommonLinkCheckbox
        key={`instagram-slider-linked-posts-checkbox-key-${item.id}`}
        linkId={item.id}
        initialValue={item.post_is_linked}
        parameter="post_is_linked"
        patchFunction={patchImageSlider}
      />
    </div>
  );
}

InstagramSliderLinkedPosts.propTypes = {
  patchImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default connect(
  null,
  {
    patchImageSlider,
  },
)(InstagramSliderLinkedPosts);
